import { createAction, props } from '@ngrx/store';
import { Portal } from '../../models/portal.model';

export const LoadActivePortal = createAction('[Portals] Load Active Portal', props<{ name?: string }>());
export const LoadActivePortalSuccess = createAction('[Portals] Load Active Portal Success', props<{ activePortal: Portal }>());
export const LoadActivePortalFail = createAction('[Portals] Load Active Portal Fail', props<{ error: any }>());
